import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1061Status: 'idle',
    startProcess1061Error: undefined as any,
    loadUserParamsProcess1061Status: 'idle',
    loadUserParamsProcess1061Error: undefined as any,

    process1061List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1061 = createAsyncThunk('process1061Slice/startProcess1061', async ({ process1061 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1061/`,
        prepareData(process1061),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1061Status } = getState().process1061Slice
        return startProcess1061Status !== 'pending'
    }
})

export const loadUserParamsProcess1061 = createAsyncThunk('process1061Slice/loadUserParamsProcess1061', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1061/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1061Status } = getState().process1061Slice
        return loadUserParamsProcess1061Status !== 'pending'
    }
})

const Process1061Slice = createSlice({
    name: 'process1061Slice',
    initialState,
    reducers: {
        resetstartProcess1061: (state) => {
            state.job = undefined
            state.startProcess1061Error = undefined
        },
        resetstartProcess1061Error: (state) => {
            state.startProcess1061Error = undefined
        },
        resetloadUserParamsProcess1061: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1061Error = undefined
        },
        resetloadUserParamsProcess1061Error: (state) => {
            state.loadUserParamsProcess1061Error = undefined
        },
        removeFromProcess1061ListById: (state, action) => {
            state.process1061List = state.process1061List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1061ListByIds: (state, action) => {
            state.process1061List = state.process1061List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1061List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1061Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1061List = []
            state.startProcess1061Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1061.pending, (state) => {
            state.startProcess1061Status = 'pending'
            state.startProcess1061Error = undefined
        })
        builder.addCase(startProcess1061.fulfilled, (state, action) => {
            state.startProcess1061Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1061.rejected, (state, action) => {
            state.startProcess1061Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1061Error = action.error.message
            } else {
                state.startProcess1061Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1061.pending, (state) => {
            state.loadUserParamsProcess1061Status = 'pending'
            state.loadUserParamsProcess1061Error = undefined
        })
        builder.addCase(loadUserParamsProcess1061.fulfilled, (state, action) => {
            state.loadUserParamsProcess1061Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1061.rejected, (state, action) => {
            state.loadUserParamsProcess1061Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1061Error = action.error.message
            } else {
                state.loadUserParamsProcess1061Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1061,
    resetstartProcess1061Error,
    resetloadUserParamsProcess1061,
    resetloadUserParamsProcess1061Error,
    removeFromProcess1061ListById,
    removeFromProcess1061ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1061Slice.actions
export default Process1061Slice.reducer
